import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { reactivateAccountAction } from "../redux/actions";
import { getQueryParamsFromUrl } from "../utils/helpers";

interface DispatchProps {
  reactivateAccountAction: Function;
}

type Props = RouteComponentProps & DispatchProps;

const Reactivate: React.FC<Props> = ({
  match,
  history,
  reactivateAccountAction,
}) => {
  useEffect(() => {
    const { token } = match.params as any;
    const { email } = getQueryParamsFromUrl(history.location.search);

    reactivateAccountAction(token, email, () =>
      history.push(`/login${history.location.search}`)
    );
  }, [match, history, reactivateAccountAction]);

  return null;
};

const matp = {
  reactivateAccountAction,
};

export default connect(null, matp)(Reactivate);
